<template>
	<div>
		<SOInputPhoto v-model="file" :page-title="'Bukti Settlement'"/>
	</div>
</template>

<script>
import SOInputPhoto from "@/so-components/global/input/SOInputPhoto";

export default {
	name: "Coba",
	components: {
		SOInputPhoto,
	},
	data() {
		return {
			file: null,
		}
	}

}
</script>

<style scoped>

</style>